"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asset = void 0;
var joi_1 = __importDefault(require("joi"));
var constants_1 = require("@hobt/constants");
exports.asset = joi_1.default.object({
    bankAccount: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    cashEquivalents: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .optional(),
    other: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .optional(),
    owner: joi_1.default.number()
        .integer()
        .min(constants_1.Owner.BorrowerCoborrower)
        .max(constants_1.Owner.Guarantor)
        .options({ convert: false })
        .required(),
    primaryResidence: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    rentalProperty: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .optional(),
    rrspRespRrif: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    savingAccount: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    vehicle: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
});
exports.default = { asset: exports.asset };
